const initialState = {
  editing: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'TOGGLE_CHANNEL_EDIT': {
      return {
        ...state,
        editing: !state.editing,
      };
    }
    case 'CHANNEL_UPDATED': {
      return {
        ...state,
        editing: false,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/ChannelDetails/ChannelDetails.reducer.js